import { render } from "./Credit.vue?vue&type=template&id=bca92c3a&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"

import "./Credit.vue?vue&type=style&index=0&id=bca92c3a&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca92c3a"]])

export default __exports__